<template>
    <div :style="generateStyle()">
      <div v-for="cp in generateComponents()" :key="cp">
        <SingleCard :control="cp" v-if="cp.type==$common.PG_COMPONENT_NAV_CARD"/>
        <ListComponent :control="cp" v-if="cp.type==$common.PG_COMPONENT_NAV_LIST"/>
        <BtnComponent :control="cp" v-if="cp.type==$common.PG_COMPONENT_NAV_BTN"/>
        <HtmlComponent :component="cp" v-if="cp.type==$common.PG_COMPONENT_HTML"/>
        <RichText :component="cp" v-if="cp.type==$common.PG_COMPONENT_RICHTEXT"/>
        <ImagesComponent :component="cp" v-if="cp.type==$common.PG_COMPONENT_ALBUM"/>
        <AudioVideo :component="cp" :srid="srid" v-if="cp.type==$common.PG_COMPONENT_AUDIO_VIDEO"/>
        <FilesComponent :component="cp" v-if="cp.type==$common.PG_COMPONENT_FILE"/>
        <ContactComponent :component="cp" v-if="cp.type==$common.PG_COMPONENT_CONTACT"/>
        <TableComponent :component="cp" v-if="cp.type==$common.PG_COMPONENT_TABLE"/>
        <SingleText :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_INPUT"/>
        <MultiText :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_MULTILINE_INPUT"/>
        <NumberControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_NUMERIC_INPUT"/>
        <IdControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_ID_INPUT"/>
        <DateControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_DATE_INPUT"/>
        <TimeControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_TIME_INPUT"/>
        <SwitchControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_CHECKLIST_INPUT"/>
        <RadioControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_RADIO_INPUT"/>
        <RatingControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_RATING_INPUT"/>
        <CheckBox :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_CHECKBOX_INPUT"/>
        <LocationControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_LOCATION_INPUT"/>
        <AddressControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_ADDRESS_INPUT"/>
        <SignatureControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_SIGNATURE_INPUT"/>
        <PhotoControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_PICS_INPUT"/>
        <WechatControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_WECHAT_INPUT"/>
        <MobileControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_MOBILE_INPUT"/>
        <ChepaiControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_CHEPAI_INPUT"/>
        <SubmitControl :control="cp" v-if="cp.type==$common.FORM_CONTROL_SUBMIT" @submit="onSubmit()" />
        <FieldComponent :component="cp" v-if="cp.type==$common.DATA_CONTROL_FIELD"/>
        <NameControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_NAME_INPUT"/>
        <DuojiControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_DUOJI_INPUT"/>
        <TableControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_TABLE_INPUT"/>
        <GonghaoControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_GONGHAO_INPUT"/>
        <GenderControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_GENDER_INPUT"/>
        <FileControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_FILE_INPUT"/>
        <VideoControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_VIDEO_INPUT"/>
        <AudioControl :ref="cp.key" :control="cp" v-if="cp.type==$common.FORM_CONTROL_AUDIO_INPUT"/>
        <Add2contactComponent :ref="cp.key" :control="cp" v-if="cp.type==$common.PG_COMPONENT_ADD2CONTACT"/>
        <ComponentContainer :ref="'container'" :control="cp" :pg="false" :components="null" v-if="cp.type==$common.PG_COMPONENT_CONTAINER" @submit="onSubmit()"/>
      </div>
    </div>
</template>

<script>
import HtmlComponent from './pg/Html.vue'
import RichText from './pg/Richtext.vue'
import ImagesComponent from './pg/Images.vue'
import AudioVideo from './pg/Audiovideo.vue'
import FilesComponent from './pg/Files.vue'
import ContactComponent from './pg/Contact.vue'
import TableComponent from './pg/Table.vue'
import BtnComponent from './pg/nav/Btn.vue'
import ListComponent from './pg/nav/List.vue'
import SingleCard from './pg/nav/Singlecard.vue'
import SingleText from './form/Singletext.vue'
import MultiText from './form/Multitext.vue'
import NumberControl from './form/Number.vue'
import IdControl from './form/Id.vue'
import DateControl from './form/Date.vue'
import TimeControl from './form/Time.vue'
import SwitchControl from './form/Switch.vue'
import RadioControl from './form/Radio.vue'
import CheckBox from './form/Checkbox.vue'
import LocationControl from './form/Location.vue'
import AddressControl from './form/Address.vue'
import SignatureControl from './form/Signature.vue'
import PhotoControl from './form/Photo.vue'
import WechatControl from './form/Wechat.vue'
import MobileControl from './form/Mobile.vue'
import ChepaiControl from './form/Chepai.vue'
import SubmitControl from './form/Submit.vue'
import NameControl from './form/Name.vue'
import DuojiControl from './form/Duoji.vue'
import TableControl from './form/Table.vue'
import GonghaoControl from './form/Gonghao.vue'
import GenderControl from './form/Gender.vue'
import FileControl from './form/File.vue'
import VideoControl from './form/Video.vue'
import AudioControl from './form/Audio.vue'
import RatingControl from './form/Rating.vue'
import FieldComponent from './data/Field.vue'
import Add2contactComponent from './pg/Add2contact.vue'
import LoginControl from './form/Login.vue'
import MessageControl from './form/Message.vue'
import axios from 'axios'

export default {
  name: 'ComponentContainer',
  components: {
    RichText,
    HtmlComponent,
    ImagesComponent,
    AudioVideo,
    FilesComponent,
    ContactComponent,
    TableComponent,
    BtnComponent,
    ListComponent,
    SingleCard,
    SingleText,
    MultiText,
    NumberControl,
    IdControl,
    DateControl,
    TimeControl,
    SwitchControl,
    RadioControl,
    RatingControl,
    CheckBox,
    LocationControl,
    AddressControl,
    SignatureControl,
    PhotoControl,
    WechatControl,
    MobileControl,
    ChepaiControl,
    SubmitControl,
    FieldComponent,
    NameControl,
    DuojiControl,
    TableControl,
    GonghaoControl,
    GenderControl,
    FileControl,
    VideoControl,
    AudioControl,
    Add2contactComponent
  },
  data() {
    return {
    }
  },
  props: {
    control:null,
    components: null,
    pg:Boolean
  },
  methods:{
    onSubmit(){

      if(this.pg)
        this.submitData();
      else
        this.$emit('submit');

    },
    submitData(){

        let components=this.generateComponents();

        this.$common.form_valid=true;

        this.$common.form_data=[];

        this.$common.submit_btn=null;

        this.scanComponents(components);

        if(!this.$common.submit_btn){

          this.$toast.add({severity:'error', summary: this.TITLE, detail:this.$t('message.invalid_operation'), life: 3000});

          return;

        }

        if(!this.$common.form_valid)
          return;

        const _this=this;
        // check access control
        if(!this.$common.userid)
          {
                
                const access_control=this.$common.submit_btn.data.access_control;

                const login_required=access_control.login_required||(access_control.user.blacklist.length+access_control.role.blacklist.length>0)||!access_control.default_allow;

                if(login_required)
                  this.$dialog.open(LoginControl, {
                    props: {
                          style: {
                              width: '100vw',
                              height: '100vh',
                          },
                          modal: true,
                          closable:false,
                          showHeader:false,
                          maximizable:true
                    },
                    data:{
                      message:this.$t('message.submit_require_login'),
                      qrid:this.$common.qrid
                    },
                    onClose() {

                        _this.doSubmit();

                    }
                  });
                else
                  this.doSubmit();

          }  
        else
          this.doSubmit();

    },
    doSubmit(){

      const _this=this;

      const access_control=this.$common.submit_btn.data.access_control;

      const access=this.$common.checkAccess(access_control);

      if(!access){

          this.$dialog.open(MessageControl, {
                  props: {
                        style: {
                            width: '100vw',
                            height: '100vh',
                        },
                        modal: true,
                        closable:false,
                        showHeader:false,
                        maximizable:true
                  },
                  data:{
                    message:this.$t('message.submit_not_allowed')
                  }
                });

          return;

      }

      

      // confirmation if needed

      if(this.$common.submit_btn.data.settings.events.beforesubmit.confirm)
      {

        this.$confirm.require({
                message: this.$common.submit_btn.data.settings.events.beforesubmit.body,
                header: this.$common.submit_btn.data.settings.events.beforesubmit.title,
                acceptLabel: this.$t('message.ok'),
                rejectLabel:this.$t('message.cancel'),
                accept: () => {

                    //callback to execute when user confirms the action
                    _this.postData();

                },
                reject: () => {
                    return;
                }
            });

      }
      else
      {

        _this.postData();

      }

    },
    postData(){

      this.$common.submitting=true;

      const formdatakey=this.$common.generateKey();

      axios
      .post(this.$common.HOST+'/formdata/create.html',{
                    access_token:this.$common.access_token,
                    qrkey:this.$common.key,
                    subkey:this.$common.sk,
                    pagekey:this.$common.pgkey,
                    formdata:this.$common.form_data,
                    formdatakey:formdatakey}
            )
      .then(response => {

          const status=response.data.status;

          if(status==1)
          {
              
            if(this.$common.submit_btn.data.settings.events.aftersubmit.action==1) // stay on the same page
              this.$toast.add({severity:'success', summary: this.TITLE, detail:'Data submitted', life: 3000});
            else
            {

              this.$common.gotoLink(this.$router,this.$common.submit_btn.data.settings.events.aftersubmit.navigation);

            }

          }
          else{
            this.$toast.add({severity:'error', summary: this.TITLE, detail:'Submitting data failed!', life: 3000});
          }

          this.$common.submitting=false;

      })
      .catch(() => {

          this.$common.submitting=false;

          this.$toast.add({severity:'error', summary: this.TITLE, detail:'Submitting data error!', life: 3000});

      })

    },
    scanComponents(){

      const components=this.generateComponents();

      for(var i=0;i<components.length;i++){

        if(components[i].type==this.$common.FORM_CONTROL_SUBMIT)
          this.$common.submit_btn=components[i];
        //else if(components[i].type==this.$common.PG_COMPONENT_CONTAINER)
        //  this.scanComponents(components[i].data.data);
        else if(components[i].key!='')
        {

            const result = this.$refs[components[i].key][0].validateData();

            if(!result.valid)
            {

              //this.$toast.add({severity:'error', summary: this.TITLE, detail:'Invalid data!', life: 3000});

              this.$common.form_valid=result.valid;

              return;

            }
            else
            {

              if(result.type==1||result.type==2||result.type==5)
                this.$common.form_data.push({controlkey:components[i].key,data:result.data,type:result.type});

            }  

        }

      }

      if(this.$refs.container)
        for(var j=0; j<this.$refs.container.length; j++){

          this.$refs.container[j].scanComponents();

          if(!this.$common.form_valid)
            return;

        }

    },
    generateStyle(){

      if(!this.pg){

          //this.cps=this.control.data.data;

          if(!this.control)
            return {};

          const componentStyle=this.$common.generateStyle(this.control.data.style);

          const layoutStyle=this.$common.generateLayoutStyle(this.control.data.layout);

          return {...componentStyle,...layoutStyle};

      }
      else
          return {};

    },
    generateComponents(){

      if(!this.pg){

        if(!this.control)
          return {};

        return this.control.data.data;

      }
      else
      {

        if(!this.components)
          return {};

        return this.components;

      }

    }
  },
  created(){

    


  }

  
}
</script>

<style>


</style>
